import { render, staticRenderFns } from "./invitedDatails.vue?vue&type=template&id=7bb8684d&scoped=true"
import script from "./invitedDatails.vue?vue&type=script&lang=js"
export * from "./invitedDatails.vue?vue&type=script&lang=js"
import style0 from "./invitedDatails.vue?vue&type=style&index=0&id=7bb8684d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8684d",
  null
  
)

export default component.exports